import { useMutation } from '@apollo/client';
import { RequestBooking, RequestBookingInput } from '../../shared/types';
import {
    UpdateStatusRequestBookingResponse,
    UpdateStatusRequestBookingRequest,
    CITRIN_UPDATE_REQUEST_BOOKING_STATUS,
} from '../index';

type UpdateMutationFunction = (request: RequestBooking) => Promise<RequestBooking | undefined>;

export const useUpdateStatusRequestBooking = (): { mutation: UpdateMutationFunction; loading: boolean } => {
    const [mutation, { loading }] = useMutation<UpdateStatusRequestBookingResponse, UpdateStatusRequestBookingRequest>(
        CITRIN_UPDATE_REQUEST_BOOKING_STATUS
    );

    const promiseMutation: UpdateMutationFunction = async (request: RequestBooking) => {
        const result = await mutation({
            variables: { request },
        });
        return result?.data?.CITRIN_MGT_updateRequestBookingStatus;
    };

    return {
        mutation: promiseMutation,
        loading,
    };
};
